module.exports = __webpack_public_path__ + "static/destination-paris-49569ab289619c28aff5e25b8a6c472a.jpg";